import { api } from '@/shared/utils/api';

export async function verifyCode(email: string, code: string) {
  return await api({
    method: 'POST',
    url: '/auth/code/verify',
    data: { email, code },
  });
}
